import { render, staticRenderFns } from "./Popup-combine.vue?vue&type=template&id=c1e6dbfa&"
import script from "./Popup-combine.vue?vue&type=script&lang=ts&"
export * from "./Popup-combine.vue?vue&type=script&lang=ts&"
import style0 from "./Popup-combine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports